import always from 'ramda/es/always';
import evolve from 'ramda/es/evolve';
import omit from 'ramda/es/omit';
import assoc from 'ramda/es/assoc';

import {
  EDULEVELS_FILTER_REQUEST,
  EDULEVELS_FILTER_SUCCESS,
  EDULEVELS_FILTER_FAILURE,
  EDULEVELS_FILTER_CLEAR,
  EDULEVELS_FILTER_DELETE,
  EDULEVELS_FILTER_SET,
  EDULEVELS_FILTER_UPDATE,
} from 'app/actions/reports/filters/educationLevels';


const defaultState = {
  data: {},
  selected: {},
  loading: true,
  active: false,
};

const educationLevels = (state = defaultState, { type, payload }) => {
  switch (type) {
    case EDULEVELS_FILTER_REQUEST: {
      return { ...state, loading: true };
    }
    case EDULEVELS_FILTER_SUCCESS: {
      return evolve({
        data: always(payload),
        loading: always(false),
      }, state);
    }
    case EDULEVELS_FILTER_FAILURE: {
      return { ...state, loading: false };
    }
    case EDULEVELS_FILTER_CLEAR: {
      return defaultState;
    }
    case EDULEVELS_FILTER_DELETE: {
      return evolve({ selected: omit(payload) }, state);
    }
    case EDULEVELS_FILTER_SET: {
      return assoc('selected', payload, state);
    }
    case EDULEVELS_FILTER_UPDATE: {
      return { ...state, ...payload };
    }
    default:
  }
  return state;
};

export default educationLevels;
